import { useCallback, useEffect, useState } from 'react';

import useCommonStore from '@/stores/pure/CommonStore';

const useFetch = (
  callback: (params?: any) => any,
  disable?: boolean,
): boolean => {
  const appInit = useCommonStore((state) => state.appInit);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    await callback();
    setLoading(false);
  }, [callback]);

  useEffect(() => {
    if (!disable && appInit) {
      fetchData();
    }
  }, [appInit, disable, fetchData]);

  return loading;
};

export default useFetch;
